module.exports = __webpack_public_path__ + "23-o2.jpg?39b5713b19eb2dc9774ed9da2bf7c05e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/23-o2.jpg
// module id = 647
// module chunks = 0